import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as award from '../award'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: award.RESOURCE.payload.dimension.partialId,
      partialId: award.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'Research Type',
    partialId: PartialId.Standard.create('research_type'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.researchType.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
